import { useSetRecoilState } from 'recoil'
import { SubscriptionsTable } from 'src/views/subscriptions/table'
import { SUBSCRIPTION_UPDATE_STEPS } from 'src/atoms/payments'

import * as paymentsAtoms from 'src/atoms/payments'

export const PaymentPlans = () => {
  const setSubscriptionUpdateType = useSetRecoilState(paymentsAtoms.subscriptionUpdateType)
  const setSubscriptionUpdateStep = useSetRecoilState(paymentsAtoms.subscriptionUpdateStep)

  const onUpgrade = () => {
    setSubscriptionUpdateType('upgrade')
    setSubscriptionUpdateStep(SUBSCRIPTION_UPDATE_STEPS.PAYMENT)
  }

  const onDowngrade = () => {
    setSubscriptionUpdateType('downgrade')
    setSubscriptionUpdateStep(SUBSCRIPTION_UPDATE_STEPS.PAYMENT)
  }

  return <SubscriptionsTable onUpgrade={onUpgrade} onDowngrade={onDowngrade} />
}
